import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/**
 * Cases page state shared with the global drawer host: which case the
 * viewCase drawer should show.
 */
export interface ICasesSlice {
  selectedCaseUuid: string | null;
}

const initialState: ICasesSlice = {
  selectedCaseUuid: null,
};

export const casesSlice = createSlice({
  name: "casesSlice",
  initialState,
  reducers: {
    setSelectedCaseUuid: (state, action: PayloadAction<string | null>) => {
      state.selectedCaseUuid = action.payload;
    },
  },
});

export const { setSelectedCaseUuid } = casesSlice.actions;
